<template>
    <v-select dense outlined v-bind="$attrs" :items="items" item-text="displayTitle" item-value="id" v-on="$listeners">
        <template #item="{ item }"
            >{{ item.displayTitle }}<span v-if="!item.is_active">&nbsp;(inaktiv)</span>
        </template>
    </v-select>
</template>

<script>
import { AddressCollection } from '@/models/Address';

export default {
    name: 'AutorSelect',

    props: {
        onlyActive: {
            type: Boolean,
            default: false,
        },
        onlyInactive: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        const authors = new AddressCollection();
        authors.setRemoteSort([
            { property: 'title', direction: 'ASC' },
            { property: 'id', direction: 'ASC' },
        ]);
        authors.addExtraParam('fetch_assigned_autors', true);
        authors.setFilter('type', 'address');
        return {
            collection: authors,
        };
    },

    computed: {
        items() {
            // here we could filter the models, if needed
            return this.collection ? this.collection.models : [];
        },
    },

    watch: {
        onlyActive(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.loadData({ force: true });
            }
        },
        onlyInactive(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.loadData({ force: true });
            }
        },
    },

    mounted() {
        this.loadData();
    },

    methods: {
        reload() {
            this.loadData({ force: true });
        },

        async loadData({ force } = {}) {
            if (force || !this.collection.length) {
                this.collection.removeFilter('is_active');
                if (this.onlyActive) {
                    this.collection.setFilter('is_active', true, 'IS');
                } else if (this.onlyInactive) {
                    this.collection.setFilter('is_active', false, 'IS');
                }
                this.collection.query();
            }
        },
    },
};
</script>
